import { FC } from 'react'
import { Box } from '@mui/material'

export const Home: FC = () => {
  return (
    <Box
      sx={{
        width: '100vw',
        height: '100vh',
        overflow: 'hidden',
        position: 'fixed',
        top: 0,
        left: 0,
      }}
    >
      <iframe
        src="https://support.medilabai.com/ebd/1ce76a51b0c780ffbb22c7cf95f01f6f"
        width="100%"
        height="100%"
        frameBorder="0"
        allowFullScreen
        style={{ border: 'none' }}
      />
    </Box>
  )
}
